module.exports = __webpack_public_path__ + "static/media/2.fd00af42.JPG";